import { ConfigSiteContext } from '@contexts/config-site'
import { ContentType } from '@entries/content-types'
import ContentfulSiteSeo from '@entries/contentful-site-seo'
import { Entry } from '@resolvers/entry'
import React, { type FC, useContext } from 'react'

export const SiteSeo: FC = () => {
  const configSite = useContext(ConfigSiteContext)

  return (
    <Entry
      content={configSite}
      mapping={{
        [ContentType.ContentfulSite]: ContentfulSiteSeo,
      }}
    />
  )
}
